import { useEffect } from "react";
import { BookOpen, X } from "lucide-react";
import { createPortal } from "react-dom";

export default function ExplicacaoTermoModal({ termo, aoFechar }) {
  useEffect(() => {
    function fecharComEscape(event) {
      if (event.key === "Escape") aoFechar();
    }

    document.addEventListener("keydown", fecharComEscape);
    document.body.style.overflow = "hidden";

    return () => {
      document.removeEventListener("keydown", fecharComEscape);
      document.body.style.overflow = "";
    };
  }, [aoFechar]);

  return createPortal(
    <div
      className="teste-cego-modal teste-cego-glossario-modal"
      role="presentation"
      onMouseDown={(event) => {
        if (event.target === event.currentTarget) aoFechar();
      }}
    >
      <section
        className="teste-cego-modal__janela teste-cego-glossario-modal__janela"
        role="dialog"
        aria-modal="true"
        aria-labelledby="titulo-modal-glossario"
      >
        <header className="teste-cego-modal__cabecalho teste-cego-glossario-modal__cabecalho">
          <div>
            <p className="teste-cego__legenda"><BookOpen size={14} /> Explicação rápida</p>
            <h2 id="titulo-modal-glossario" className="teste-cego__titulo-modal">{termo.titulo}</h2>
          </div>
          <button
            type="button"
            className="teste-cego-glossario-modal__fechar focus-ring"
            onClick={aoFechar}
            aria-label={`Fechar explicação sobre ${termo.termo}`}
          >
            <X size={20} />
          </button>
        </header>
        <div className="teste-cego-glossario-modal__conteudo">
          <p className="teste-cego-glossario-modal__definicao">{termo.explicacao}</p>
          <aside className="teste-cego-glossario-modal__contexto">
            <span>Por que isso aparece aqui?</span>
            <p>{termo.contexto}</p>
          </aside>
        </div>
      </section>
    </div>,
    document.body,
  );
}
